import { render, staticRenderFns } from "./ActItem.vue?vue&type=template&id=50f1df25&"
import script from "./ActItem.vue?vue&type=script&lang=js&"
export * from "./ActItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports